import React from 'react';

function MedicineListItem({ item, onQuantityChange, onDiscountChange, onRemove, calculateItemPrice }) {
  const { medicine, quantity, discount } = item;
  
  // Ensure we have a string ID
  const medicineId = medicine.id.toString();
  const medicineName = medicine.name || '';
  const manufacturer = medicine.manufacturer || '';
  const content = medicine.content || '';
  const size = medicine.size || 1;
  const price = parseFloat(medicine.price || 0);
  const priceToRetailer = parseFloat(medicine.price_to_retailer || 0);
  const packingSize = medicine.packing_size || '';
  const batch = medicine.batch || '';
  const expiry = medicine.expiry || '';
  const discountTier = medicine.discount_tier;

  const isCustomMedicine = medicineId && medicineId.startsWith('custom-');

  return (
    <div className="border rounded-lg p-4">
      <div className="flex justify-between">
        {/* Remove button - Moved up and aligned with medicine name */}
        <div className="flex-grow">
          <div className="flex justify-between items-start mb-2">
            <h3 className="font-semibold text-gray-800 text-lg">{medicineName}</h3>
            <button 
              onClick={() => onRemove(medicineId)}
              className="text-red-600 hover:text-red-800 flex items-center space-x-1"
            >
              <i className="material-icons-outlined text-base">delete</i>
              <span>Remove</span>
            </button>
          </div>

          <div className="flex items-center gap-16">
            {/* Medicine Details */}
            <div className="w-1/2">
              <div className="mt-1 space-y-1">
                {manufacturer && (
                  <p className="text-sm text-gray-600">
                    Manufacturer: <span className="font-medium">{manufacturer}</span>
                  </p>
                )}
                {content && (
                  <p className="text-sm text-gray-600">
                    Salt: <span className="font-medium">{content}</span>
                  </p>
                )}
                {packingSize && (
                  <p className="text-sm text-gray-600">
                    Pack Size: <span className="font-medium">{packingSize}</span>
                  </p>
                )}
                {batch && batch !== 'Not Specified' && (
                  <p className="text-sm text-gray-600">
                    Batch: <span className="font-medium">{batch}</span>
                    {expiry && (
                      <>
                        <span className="mx-2">•</span>
                        Expires: <span className="font-medium">
                          {new Date(expiry).toLocaleDateString('en-US', { month: 'short', year: '2-digit' })}
                        </span>
                      </>
                    )}
                  </p>
                )}
                {/* Only show discount tier for custom medicines */}
                {isCustomMedicine && discountTier && (
                  <p className="text-sm text-gray-600">
                    Discount Tier: <span className="font-medium">{discountTier}</span>
                  </p>
                )}
                <p className="text-sm text-gray-600">
                  MRP: <span className="font-medium">₹{price.toFixed(2)}</span>
                </p>
                <p className="text-sm text-gray-600">
                  PTR: <span className="font-medium">₹{priceToRetailer.toFixed(2)}</span>
                </p>
              </div>
            </div>

            {/* Controls Section */}
            <div className="flex items-center space-x-8 w-1/2 justify-end">
            <div className="flex items-center space-x-2 w-24 ml-15">
                <span className="text-sm font-medium text-gray-700 whitespace-nowrap">Loss Qty:</span>
                <span className="text-sm font-bold text-gray-700 whitespace-nowrap">{size * quantity}</span>
              </div>

              <div className="flex items-center space-x-2 w-24">
                <span className="text-sm font-medium text-gray-700 whitespace-nowrap">Qty:</span>
                <input
                  type="number"
                  min="1"
                  max={medicine.stock}
                  value={quantity}
                  onChange={(e) => onQuantityChange(medicine.id, medicine.batch, e.target.value)}
                  className="input-field w-16 h-8 px-2"
                />
              </div>

              <div className="flex items-center space-x-2 w-32">
                <span className="text-sm font-medium text-gray-700 whitespace-nowrap">Discount:</span>
                <div className="flex items-center">
                  <input
                    type="number"
                    min="0"
                    max="100"
                    value={discount}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      onDiscountChange(parseFloat(newValue) || 0);
                    }}
                    className="input-field w-16 h-8 px-2"
                  />
                  <span className="ml-1 text-gray-600">%</span>
                </div>
              </div>

              <div className="flex items-center space-x-2 min-w-[160px]">
                <span className="text-sm font-medium text-gray-700">Total:</span>
                <div className="flex flex-col items-end">
                  <span className="text-lg font-semibold text-gray-800">
                    ₹{calculateItemPrice(item).toFixed(2)}
                  </span>
                  {(discount > 0 && price && quantity) && (
                    <span className="text-sm text-gray-500 line-through">
                      ₹{(price * quantity).toFixed(2)}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MedicineListItem; 